import { type NuxtApp } from '#app/nuxt';
import { defineNuxtPlugin, useRouter } from '#imports';
import { initMatomo } from '~/utils/matomo/init';
import { registerMatomoRouter } from '~/utils/matomo/registerRouterHook';

const defer = (cb: () => void) => {
    if ('requestIdleCallback' in window) {
        (window as any).requestIdleCallback(cb)
    } else {
        setTimeout(cb, 1500)
    }
}

export default defineNuxtPlugin((nuxt: NuxtApp) => {
    if (!process.client) {
        return;
    }

    const router = useRouter();

    defer(async () => {
        const enabled = await initMatomo(nuxt);

        if (enabled) {
            registerMatomoRouter(router, nuxt);
        }
    })
})
